import React, { useState } from 'react';

interface AddLetterModuleProps {
  show: boolean;
  onHide: () => void;
  onLetterAdded: (payload: {
    date: string;
    referenceNo: string;
    letterType: string;
    senderDetails: string;
    letterDescription?: string;
  }) => void;
}

const AddLetterModule: React.FC<AddLetterModuleProps> = ({ show, onHide, onLetterAdded }) => {
  const [formData, setFormData] = useState({
    date: '',
    referenceNo: '',
    letterType: 'REGISTER_POST',
    senderDetails: '',
    letterDescription: '',
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onLetterAdded(formData);
  };

  return (
    <div className="modal custom-modal fade show" id="addLetterModal" role="dialog" style={{ display: show ? 'block' : 'none' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add Letter</h5>
            <button className="btn-close" onClick={onHide} aria-label="Close">
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="col-form-label">Date <span className="text-danger">*</span></label>
                <input
                  type="date"
                  className="form-control"
                  name="date"
                  value={formData.date}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="col-form-label">Reference No <span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  name="referenceNo"
                  value={formData.referenceNo}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="col-form-label">Letter Type <span className="text-danger">*</span></label>
                <select
                  className="form-control"
                  name="letterType"
                  value={formData.letterType}
                  onChange={handleInputChange}
                  required
                >
                  <option value="REGISTER_POST">Registered Post</option>
                  <option value="NORMAL_POST">Normal Post</option>
                  <option value="PARCEL">Parcel</option>
                </select>
              </div>
              <div className="mb-3">
                <label className="col-form-label">Sender Details <span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  name="senderDetails"
                  value={formData.senderDetails}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="col-form-label">Description</label>
                <input
                  type="text"
                  className="form-control"
                  name="letterDescription"
                  value={formData.letterDescription}
                  onChange={handleInputChange}
                />
              </div>
              <div className="modal-btn">
                <button type="button" className="btn btn-primary" onClick={onHide}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-success">
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddLetterModule;